import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import tables from "../../../../Data/Tables/Purchases/Return/tables";
import headers from "../../../../Data/Tables/Purchases/Return/headers";
import purchase_return from "../../../../Data/purchase_return.json";
import ActionButton from "../../../../Componets/Buttons/action";
import toast from "react-hot-toast";

const PurchasesReturnTable = () => {
  let header = headers;
  let head = tables;

  const [body, setBody] = useState();
  const [previousPage, setPreviousPage] = useState(1);
  const [isSearching, setIsSearching] = useState(false);
   const [pagination, setPagination] = useState({
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
    });
  

  const fetchData = async () => {
    try {
      let data = [];

      purchase_return?.map((value, index) => {
        data?.push({
          Number: value?.return,
          Purchase: value?.number,
          Date: value?.date,
          Amount: value?.amount,
          Payment: value?.payment,
          Action: <ActionButton edit={`/`} delete="/" headers={header} />,
        });
      });

      setBody(data);
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const formdata = async (data) => {
    console.log(data);
    if (data?.search && !isSearching) {
      setPreviousPage(pagination.currentPage);
      setIsSearching(true);
    }

    if (!data?.search && isSearching) {
      setIsSearching(false);
      fetchData({
        ...data,
        currentPage: previousPage,
        totalCount: pagination?.totalCount,
        totalPages: pagination?.totalPages,
      });
      return;
    }

    let page = data?.search ? 1 : pagination?.currentPage;

  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={header} formdata={formdata}>
      <Table head={head} body={body} />
    </Header>
  );
};

export default PurchasesReturnTable;
